module.exports = __webpack_public_path__ + "static/media/add-patient-icon.8dc2bca5.svg";